import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
    {
        path: '/warehouse',
        component: () => import('@/layouts/ModuleLayout.vue'),
        meta: {
            moduleKey: 'fab_scheduler',
        },
        children: [
            {
                path: '',
                redirect: { name: 'fab-schedule' },
            },
            {
                path: 'fab-schedule',
                name: 'fab-schedule',
                component: () => import('./views/FabScheduleView.vue'),
                meta: {
                    title: 'Fab Schedule',
                },
            },
            {
                path: 'import-schedule',
                name: 'fab-schedule-import',
                component: () => import('@/modules/imports/views/FabScheduleImportWizard.vue'),
                meta: {
                    title: 'Import Schedule',
                },
            },
        ],
    },
]

export default routes
